import { Path } from "react-hook-form";
import { IPaf } from "../../_api";

export const TAB_FIELDS: Record<number, Path<IPaf>[]> = {
    0: [
        "company__company_name",
        "company__naics_code",
        "is_foreign_location",
        "is_ncoa",
        "is_dsf",
        "is_triplex",
        "is_waiver_on_file",
    ],
    1: [
        "company__address1",
        "company__city",
        "company__state",
        "company__postal_code",
    ],
    2: [
        "company__representative_name",
        "company__representative_email",
        "company__phone",
    ],
    3: ["notes", "comments"],
    4: ["licensee_acct_exec", "licensee_operator"],
};
